import Link from "next/link";
import React from "react";
import { routes } from "src/shared/routes";
import { TRegistrationCardData } from "src/shared/types/globalStotre.types";
import { TTeamConfig } from "src/shared/types/teamConfig.types";
import { createJsxLink } from "src/utils/create-jsx-link";

export const FAQS: TTeamConfig["LANGUAGES"]["FAQS"] = [
  {
    question: "How do I manage my reservations?",
    answer:
      'After registering your Knicks Garden Deck License, you can navigate to Upcoming Games and select "Reserve" next to the game you want to attend. Please note that you can hold and manage up to four (4) reservations at a time.',
  },
  {
    question: "How many games can I reserve at a time?",
    answer:
      "You may hold and manage up to four (4) different game reservations at a time.",
  },
  {
    question: "How many passes will I receive per game?",
    answer:
      "Account holders will receive up to two (2) passes for each game reservation, but you can also purchase additional guest passes while supplies last.",
  },
  {
    question: "What if I can't attend a game I reserved?",
    answer:
      "If you are unable to attend a reserved game, you must cancel at least 48 hours in advance.",
  },
  {
    question: "What if I don't cancel my reservation in time?",
    answer:
      "The Knicks reserve the right to reduce the number of game reservations you may hold at one time if you do not cancel a reservation at least 48 hours in advance.",
  },
  {
    question: "When will I get my barcodes?",
    answer: (
      <>
        Barcodes for you and your guests will become available 3 hours prior to
        the game on your{" "}
        <Link target="_blank" href="https://am.ticketmaster.com/msg/en">
          Knicks account
        </Link>
        .
      </>
    ),
  },
  {
    question: "How do I get to the Garden Deck?",
    answer:
      "The Garden Deck is located on the east side of the 300 Level. Use Tower A or D.",
  },
];

export const TERMS_AND_CONDITION = () => {
  return (
    <>
      By checking this box you agree to receive SMS alerts regarding ticket
      delivery and agree to the{" "}
      {createJsxLink("Terms of Use", "https://www.attend.tech/terms-of-use")}{" "}
      and{" "}
      {createJsxLink(
        "Privacy Policy",
        "https://www.attend.tech/privacy-policy"
      )}
      .
    </>
  );
};

export const CHECKOUT_TERMS_AND_CONDITION = () => {
  return (
    <>
      By checking this box you agree to receive SMS alerts regarding ticket
      delivery and agree to the{" "}
      <Link target="_blank" href="https://www.attend.tech/terms-of-use">
        Terms of Use
      </Link>{" "}
      and{" "}
      <Link target="_blank" href="https://www.attend.tech/privacy-policy">
        Privacy Policy
      </Link>
      .
    </>
  );
};

export const REGISTRATION_CARDS: TRegistrationCardData[] = [
  {
    title: "Knicks Garden Deck Registration",
    description: (
      <>
        Register your Knicks Garden Deck license to begin managing your
        reservations and purchase Guest Tickets. Please note you may hold and
        manage up to three (3) different game reservations at a time.
      </>
    ),
    buttonLabel: "Register",
    buttonVariant: "contained",
    authRedirectPage: routes.home,
  },
];
